export const PRIVACY_POLICY_URL = "https://www.null-leasing.com/datenschutz";

export const AGB_URL = "https://www.null-leasing.com/agb";

export const PARTNER_PORTAL_LOGIN_URL = "https://partner.null-leasing.com/login";
